export const useIsSmallDesktopScreen = () => {
  return window.innerWidth < 1200
}
